export const UPSELL_LANDING_OFFER_FLOW_NAME = 'UpsellLandingOffer';
